export type ByteOrByteArray = (number | Uint8Array);

export interface Vector3Like { x : number; y : number; z : number; };
export interface QuaternionLike { x : number; y : number; z : number; w : number; };

const encoder : TextEncoder = new TextEncoder();
export function encode(text : string) : Uint8Array { return encoder.encode(text); }

export class Writer
{
	static writeFloat( value : number, buffer : Uint8Array = new Uint8Array(4), offset = buffer.byteOffset )
	{
		const view = new DataView(buffer.buffer, offset);
		view.setFloat32(0, value, true);
		return buffer;
	}
	static writeUint32( value : number, buffer : Uint8Array = new Uint8Array(4), offset = buffer.byteOffset )
	{
		const view = new DataView(buffer.buffer, offset);
		view.setUint32(0, value, true);
		return buffer;
	}
	static writeUint64( value : number, buffer : Uint8Array = new Uint8Array(8), offset = buffer.byteOffset )
	{
		const view = new DataView(buffer.buffer, offset);
		view.setUint32(0, value % 0x100000000, true);
		view.setUint32(4, Math.floor(value / 0x100000000), true);
		return buffer;
	}
	static writeVector3( value : Vector3Like, buffer : Uint8Array = new Uint8Array(12), offset = buffer.byteOffset )
	{
		const view = new DataView(buffer.buffer, offset);
		view.setFloat32(0, value.x, true);
		view.setFloat32(4, value.y, true);
		view.setFloat32(8, value.z, true);
		return buffer;
	}
	static writeQuaternion( value : QuaternionLike, buffer : Uint8Array = new Uint8Array(16), offset = buffer.byteOffset )
	{
		const view = new DataView(buffer.buffer, offset);
		view.setFloat32(0, value.x, true);
		view.setFloat32(4, value.y, true);
		view.setFloat32(8, value.z, true);
		view.setFloat32(12, value.w, true);
		return buffer;
	}
	static writeVector3FromArray( value : number[], index : number, buffer : Uint8Array = new Uint8Array(12), offset = buffer.byteOffset )
	{
		const view = new DataView(buffer.buffer, offset);
		view.setFloat32(0, value[index], true);
		view.setFloat32(4, value[index+1], true);
		view.setFloat32(8, value[index+2], true);
		return buffer;
	}
	static writeVector3OppositeFromArray( value : number[], index : number, buffer : Uint8Array = new Uint8Array(12), offset = buffer.byteOffset )
	{
		const view = new DataView(buffer.buffer, offset);
		view.setFloat32(0, -value[index], true);
		view.setFloat32(4, -value[index+1], true);
		view.setFloat32(8, -value[index+2], true);
		return buffer;
	}
	static join( ...parts : ByteOrByteArray[] )
	{
		let length = 0;
		for(let p of parts)
			length += (typeof p === "number") ? 1 : p.byteLength;
		
		const buffer = new Uint8Array(length);
		length = 0;
		for(let p of parts)
			if(typeof p === "number")
				buffer[length++] = p;
			else
			{
				buffer.set(p, length );
				length += p.byteLength;
			}

		return buffer;
	}

};

